'use strict';

var FirebaseObject = require('./FirebaseObject');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');

var KayleeMalInfo = {
    fromJson: fromJson,
    get: getMalInfo,
};

var commitId = '-- insert commit id here --';

function fromJson(data) {
    var reqProps = [];
    return FirebaseObject.$fromJson(data, 'MalInfo', reqProps, reqProps,
        function(data) { return new getMalInfo(); }
    );
}

function getMalInfo() {
    var key = 'MalInfo';
    var malInfo = KayleeCache.get(key);

    if (malInfo === null) {
        malInfo = new MalInfo();
        KayleeCache.put(key, malInfo);
    }

    return malInfo;
}

function MalInfo() {
    this.$nodeType = 'malInfo';
    this.$thisBuild = {
        commitId: commitId.startsWith('--') ? null : commitId, // null for non-mal builds
    };
    FirebaseObject.call(this,
        KayleeBase.app.database().ref('mal'));
}

MalInfo.prototype = Object.create(FirebaseObject.prototype);
MalInfo.prototype.constructor = MalInfo;

MalInfo.prototype.$toJson = function() {
    return FirebaseObject.prototype.$toJson.call(this, []);
};

MalInfo.prototype.toString = function() {
    return '[Mal Info]';
};

module.exports = KayleeMalInfo;
